define.alias("shared/components/shared/linkinbio/slug-validator/task", "calendar/components/shared/linkinbio/slug-validator/task");